import { makeListReducer } from 'lib/list-helper/makeListReducer';

export const { reducer, initialState } = makeListReducer();
